import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-send-message",
  templateUrl: "./send-message.component.html",
  styleUrls: ["./send-message.component.scss"],
})
export class SendMessageComponent {
  message = "";

  constructor(private dialogRef: MatDialogRef<SendMessageComponent>) {}

  submit(): void {
    this.dialogRef.close(this.message);
  }

  close(): void {
    this.dialogRef.close();
  }
}
